// TODO: drop the tslint disable
export const VALIDATION_REGEX = {
  // tslint:disable-next-line
  emailRegex:
    /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
  nonEmptyorWhitespaceRegex: /.*\S.*/,
  postcodeOrTerminalCodeRegex: /^\d{3}$|^[A-Z]{4}$/,
  phoneNumberRegex: /^[+]?[-\s\./0-9]*([(][0-9]{1,4}[)])?[-\s\./0-9]*$/,
  // Icelandic Company Reg No (Icelandic SSN) validation regex - Only 10 digits (no separator)
  isIcelandicSSNRegex: /^\d{10}$/,
};
